import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { api } from '../api';
import { updateProfilePicture, updateProfileStory } from '../api';
import { profileActions } from './actions';

export function* sendUpdatedData({ payload }) {
    const { data, file } = payload;

    yield put(profileActions.fetchProfilePending());

    try {
        const profileResponse = yield call(api.updateProfile, data);

        if (!profileResponse?.success) {
            yield put(profileActions.fetchProfileFailed(profileResponse));
            return;
        }

        if (file) {
            const pictureResponse = yield call(api.updateProfilePicture, file);

            if (!pictureResponse?.success) {
                yield put(profileActions.fetchProfileFailed(pictureResponse));
                return;
            }
        }

        yield put(profileActions.fetchProfileSuccess(profileResponse.data));
    } catch (error) {
        const failedPayload = error?.response?.data ?? error;
        yield put(profileActions.fetchProfileFailed(failedPayload));
    }
}

export function* sendUpdatedPicture({ payload }) {
    const { file } = payload;
    yield call(updateProfilePicture, file);
}

export function* sendUpdatedStory({ payload }) {
    const { data } = payload;
    yield call(updateProfileStory, data);
}

//===================================== 
// WATCHERS
//-------------------------------------

export function* watchSendUpdatedData() {
    yield takeEvery(profileActions.UPDATE_PROFILE, sendUpdatedData);
}

export function* watchSendUpdatedPicture() {
    yield takeEvery(profileActions.UPDATE_PICTURE, sendUpdatedPicture);
}

export function* watchSendUpdatedStory() {
    yield takeEvery(profileActions.UPDATE_STORY, sendUpdatedStory);
}


//=====================================
//  ROOT
//-------------------------------------

export const profileSagas = [
    fork(watchSendUpdatedData),
    fork(watchSendUpdatedPicture),
    fork(watchSendUpdatedStory),
];